import { useState } from 'react';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import useAuth from '../../../hooks/useAuth';
import { WorkPhase, WorkPhaseForm } from '../models/investors';
import {
  createWorkPhaseEndpoint,
  getWorkPhasesEndpoint,
  updateWorkPhaseProgressEndpoint,
} from '../services/workPhasesService';
import { fetchResponseAdapter } from '../../../adapters/fetchAdapter';

const useProjectWorkPhases = () => {
  const { callEndpoint } = useCallApiAndLoad();
  const [apiErrors, setApiErrors] = useState<string | null>(null);

  const { getAuthToken } = useAuth();
  const token = getAuthToken();

  const doGetWorkPhases = async (projectId: string): Promise<WorkPhase[]> => {
    const { data, status } = await callEndpoint(
      getWorkPhasesEndpoint(projectId, token),
    );
    const response = fetchResponseAdapter(data);

    if (status !== 200) {
      setApiErrors(response.message);
      return [];
    }

    return Array.isArray(response.data) ? response.data : [];
  };

  const doCreateWorkPhase = async (
    projectId: string,
    payload: WorkPhaseForm,
  ): Promise<number> => {
    const { data, status } = await callEndpoint(
      createWorkPhaseEndpoint(projectId, payload, token),
    );
    const response = fetchResponseAdapter(data);

    if (status !== 201) setApiErrors(response.message);

    return status;
  };

  const doUpdateWorkPhaseProgress = async (
    projectId: string,
    phaseId: string,
    phaseProgress: number,
  ): Promise<number> => {
    const { data, status } = await callEndpoint(
      updateWorkPhaseProgressEndpoint(
        projectId,
        phaseId,
        { phase_progress: phaseProgress },
        token,
      ),
    );
    const response = fetchResponseAdapter(data);
    if (status !== 200) setApiErrors(response.message);
    return status;
  };

  return {
    apiErrors,
    doGetWorkPhases,
    doCreateWorkPhase,
    doUpdateWorkPhaseProgress,
  };
};

export default useProjectWorkPhases;
